import $ from 'jquery';
import tippy from 'tippy.js';
import Inputmask from 'inputmask';

window.$ = window.jQuery = $;
require('slick-carousel');
require('magnific-popup');

Inputmask("+7 (999) 999-99-99").mask('.phone-mask');

function hideBody() {
    $('html, body').css('overflow', 'hidden');
}

function clearBodyStyle() {
    $('html, body').removeAttr('style');
}

$(document).ready(function () {


    $('.rate-header.rate-header--pointer').on('click', function () {

        let id = $(this).data('rate-id');

        if ($(this).hasClass('rate-main--open')){
            $(this).removeClass('rate-main--open');
            $(".rate-main--room[data-rate-content="+id+"]").addClass('rate-main--hide');
            $("i.icon__chevron-room[data-rate-arrow="+id+"]").removeClass('icon__chevron-room--open');
        }else {
            $(this).addClass('rate-main--open');
            $(".rate-main--room[data-rate-content="+id+"]").removeClass('rate-main--hide')
            $("i.icon__chevron-room[data-rate-arrow="+id+"]").addClass('icon__chevron-room--open');
        }
    })


    $('.route-map__link').magnificPopup({
        type: 'image',
        closeOnContentClick: true,
        mainClass: 'mfp-img-mobile',
        image: {
            verticalFit: true
        }

    });

    tippy('[data-tippy-content]', {
        arrow: false,
        maxWidth: 200,
        // arrow: true,
        followCursor: true,
        placement: 'top-start',
        duration: 200,
        theme: 'icc',
    });

    $(document).on('click', '.gallery-link', function () {
        $(this).next().magnificPopup('open');
    });

    $(document).mouseup(function (e) {

        let menu = $('.nav__drop-body');
        let item = $('.nav__item');

        if (item.is(e.target)) {

            if ($(e.target).next('.nav__drop-body').hasClass('nav__drop-body--hide')) {

                $('.nav__drop-body').each(function (i, e) {
                    if (!$(e).hasClass('nav__drop-body--hide')) {
                        $(e).addClass('nav__drop-body--hide');
                    }
                });

                $(e.target).next('.nav__drop-body').addClass('nav__drop-body--hide');

            } else {
                $(e.target).next('.nav__drop-body').removeClass('nav__drop-body--hide');
            }

            $(e.target).next('.nav__drop-body').toggleClass('nav__drop-body--hide');
        } else if (!menu.is(e.target) && menu.has(e.target).length === 0) {
            $('.nav__drop-body').addClass('nav__drop-body--hide');
        }
    });

    $(document).on('click', '.header__menu-item', function () {
        hideBody();
        $('.menu').removeClass('menu--close').addClass('menu--open');
    });

    $(document).on('click', '.menu__header-close', function () {
        clearBodyStyle();
        $('.menu').removeClass('menu--open').addClass('menu--close');
    });

});